import { Button } from "react-bootstrap";
import { BsEye } from "react-icons/bs";
import { useState } from "react";
import AuthModal from '../Modal/AuthenticateModal';

interface ActionBarProps {
   role: string|null;
   isSubmitting: boolean;
   isSaved: boolean;
   onSubmit: (e: React.MouseEvent<HTMLButtonElement>) => void;
   onSave?: (e: React.MouseEvent<HTMLButtonElement>) => void;
   onView?: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

export default function ActionBar({role, isSaved, isSubmitting, onSave, onSubmit, onView}: ActionBarProps) {
   const canSubmit = role === 'Magazine' || role === 'Live' || role === 'IT';
   const [isModalOpen, setIsModalOpen] = useState(false); 
   const [isConfirming, setIsConfirming] = useState(false);

   const openAuthModal = () => {
      setIsModalOpen(true); 
   };
	
   const closeAuthModal = () => {
      setIsModalOpen(false); 
   };

   return (
      <>
         <AuthModal
            isOpen={isModalOpen}
            onClose={closeAuthModal}
            title="Action Verification"
            content={<div className='text-base mb-3'>Are you sure you want to save these changes?</div>}
            footer={
               <>
                  <button 
                     className="m-0 px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-400"
                     onClick={closeAuthModal}>
                     Close
                  </button>
                  <button 
                     className="m-0 px-4 py-2 text-sm font-medium text-white bg-red-500 rounded hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-400"
                     onClick={onSubmit}
                     disabled={isSubmitting}>
                     {isSubmitting ? 'Confirming...' : 'Confirm'}
                  </button>
               </>
            }
         />

         <div className='flex justify-center gap-1'>
            {canSubmit && (
               <Button variant='danger' type='button' 
                  onClick={openAuthModal}>
                  Submit
               </Button>
            )}

            {onSave && (
               <Button variant='secondary' type='button' onClick={onSave}>
                  {isSaved ? 'Saving...' : 'Save as Draft'}
               </Button>
            )}

            {onView && (
               <button type='button' data-tooltip-id='preview' className='btn btn-danger text-base' onClick={onView}>
                  <BsEye />
               </button>
            )}
         </div>
      </>
   )
}
